import { formats, getCell, withCellStyles } from '../../utils';
import { boldLightGrayBg } from '../financial-statement/capital-account/styles';
import { InitialFollowOnInvestmentExportData } from './initialFollowOnInvestmentTemplate';
import { Rows } from '../../interfaces';
import { boldGrayBgLeft, boldLightGrayBgLeft } from '../comparison/mapping';
import { CellStyle } from 'xlsx-js-style/types';
import { InitialFollowOnDTO, InitialFollowOnRatiosDTO }
  from 'src/app/domain/pp/component/sub/initial-follow-on-investment/pojo/initial-follow-on-classes';
import { nullToDash } from 'src/app/util/excelStyles';

export const getPreparedData = (data: InitialFollowOnInvestmentExportData): Rows => {

  const newData: Rows = [];
  // fisrt line of header
  newData.push(stRow);
  const row = [];
  // table headers
  data.headersForDisplay.forEach((header) => (header === '' ? row.push(null) : row.push(withCellStyles(header, boldLightGrayBg))));
  newData.push(row);
  // part of With Gain loss provided data where multiple !== 1
  const atGainData = data.data.atGain;
  const atCostData = data.data.atCost;

  if (atGainData.companiesData.length) {
    // first line before data
    newData.push([withCellStyles('With Gain/Loss', leftBold)]);
    const gainRows = getManyRows(atGainData.companiesData, data.headersForLogic);
    newData.push(...gainRows);
    // adding total for GAIN LOSS
    // using numbers needs to define start position where total starts
    const ratioAtGain = atGainData.totalData.ratios;
    const totalGainLoss = getTotalMappingGainLoss(3 + atGainData.companiesData.length, data.headersForLogic, '', 4, ratioAtGain);
    newData.push(totalGainLoss);
  }
  // check that asCost data exists
  if (atCostData.companiesData.length) {
    // adding information line  that case at cost starts
    newData.push([withCellStyles('At cost', leftBold)]);
    currentRowIndex++;

    // addning data atCost for active
    const atCostRows = getManyRows(atCostData.companiesData, data.headersForLogic, 'atCost', 2 + atGainData.companiesData.length);
    newData.push(...atCostRows);
    // adding totals for asCost
    const ratioAtCost = atCostData.totalData.ratios;
    const totalAtCost = getTotalMappingGainLoss(currentRowIndex - 1, data.headersForLogic,
      'atCost', currentRowIndex - atCostData.companiesData.length, ratioAtCost);
    newData.push(totalAtCost);
  }
  // added grand total
  if (atGainData.companiesData.length && atCostData.companiesData.length) {
    const startGrandTotal = subTotalsIndexes[0];
    const stopGrandTotal = subTotalsIndexes[1];
    const ratios = data.data.grandTotal.ratios;
    const grandTotal = getGrandTotalMapping(stopGrandTotal, data.headersForLogic, startGrandTotal, ratios);
    newData.push(grandTotal);
  }
  resetIndexes();
  return newData;
};

export const getManyRows = (data: InitialFollowOnDTO[], headers: string[], status: string = 'atCost', activeLen = 0): Rows => {
  const rows: Rows = [];
  let addStartForSold = 0;
  if (status === 'atCost') {
    addStartForSold += activeLen;
  }
  const mappedToHeaders = data.map((d, i) => getNewMapping(d, (i + addStartForSold)));

  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], left));
    }
    rows.push(row);
  }
  return rows;
};


export const getNewMapping = (portfolio: InitialFollowOnDTO, i: number): any => {
  i += 4; // data starts from row 4
  const body = {
    'Company name': portfolio.companyName,
    'Initial investment': portfolio.initialInvestment,

    'empty(0)': null,

    'Investment(0)': getCell({
      v: (portfolio.initial.cost),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(0)': getCell({
      v: nullToDash(portfolio.initial.fairValue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(0)': getCell({
      f: `IFERROR(E${i}/D${i},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(0)': getCell({
      v: nullToDash(portfolio.initial.companyValue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),

    'empty(1)': null,

    'Investment(1)': getCell({
      v: nullToDash(portfolio.followOn.cost),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(1)': getCell({
      v: nullToDash(portfolio.followOn.fairValue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(1)': getCell({
      f: `IFERROR(J${i}/I${i},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(1)': getCell({
      v: nullToDash(portfolio.followOn.companyValue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),

    'empty(2)': null,

    'Investment(2)': getCell({
      v: portfolio.total.cost,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(2)': getCell({
      v: portfolio.total.fairValue,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(2)': getCell({
      f: `IFERROR(O${i}/N${i},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(2)': getCell({
      v: nullToDash(portfolio.total.companyValue),
      z: formats.thousandsSeparator,
      t: 'n',
    }),

    'Investment ratio': portfolio.ratios.cost,

    'Value ratio': portfolio.ratios.fairValue,
  };
  currentRowIndex++;
  return body;
};

export const getTotalMappingGainLoss = (stopLen: number, headers: string[],
  status = '', startLen = 4, ratios: InitialFollowOnRatiosDTO): any[] => {
  const rows: Rows = [];
  const row = [];

  const isAtCost = status === 'atCost';

  const total = {
    'Company name': isAtCost ? 'Total at cost' : 'Total w G/L',
    'Initial investment': '',

    'empty(0)': null,

    'Investment(0)': getCell({
      f: `SUM(D${startLen}:D${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(0)': getCell({
      f: `SUM(E${startLen}:E${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(0)': getCell({
      f: `IFERROR(E${stopLen + 1}/D${stopLen + 1},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(0)': '',

    'empty(1)': null,

    'Investment(1)': getCell({
      f: `SUM(I${startLen}:I${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(1)': getCell({
      f: `SUM(J${startLen}:J${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(1)': getCell({
      f: `IFERROR(J${stopLen + 1}/I${stopLen + 1},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(1)': '',

    'empty(2)': null,

    'Investment(2)': getCell({
      f: `SUM(N${startLen}:N${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(2)': getCell({
      f: `SUM(O${startLen}:O${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(2)': getCell({
      f: `IFERROR(O${stopLen + 1}/N${stopLen + 1},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(2)': '',

    'Investment ratio': ratios.cost,

    'Value ratio': ratios.fairValue,
  };

  for (const header of headers) {
    row.push(withCellStyles(total[header], boldLightGrayBgLeft));
  }

  rows.push(row);
  subTotalsIndexes.push(currentRowIndex);
  currentRowIndex++;
  return row;
};


export const getGrandTotalMapping = (stopLen: number, headers: string[], startLen = 4, ratios: InitialFollowOnRatiosDTO): any[] => {
  const rows: Rows = [];
  const row = [];

  const total = {
    'Company name': 'Grand total',
    'Initial investment': '',

    'empty(0)': null,

    'Investment(0)': getCell({
      f: `SUM(D${startLen},D${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(0)': getCell({
      f: `SUM(E${startLen},E${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(0)': getCell({
      f: `IFERROR(E${stopLen + 1}/D${stopLen + 1},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(0)': '',

    'empty(1)': null,

    'Investment(1)': getCell({
      f: `SUM(I${startLen},I${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(1)': getCell({
      f: `SUM(J${startLen},J${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(1)': getCell({
      f: `IFERROR(J${stopLen + 1}/I${stopLen + 1},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(1)': '',

    'empty(2)': null,

    'Investment(2)': getCell({
      f: `SUM(N${startLen},N${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Value(2)': getCell({
      f: `SUM(O${startLen},O${stopLen})`,
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'MOIC(2)': getCell({
      f: `IFERROR(O${stopLen + 1}/N${stopLen + 1},0)`,
      z: formats.multiplier,
      t: 'n',
    }),
    'Comp.value(2)': '',

    'Investment ratio': ratios.cost,

    'Value ratio': ratios.fairValue,
  };

  for (const header of headers) {
    row.push(withCellStyles(total[header], boldGrayBgLeft));
  }

  rows.push(row);
  return row;
};

export const calculateRatio = (part: number, total: number): string | number => {
  if (total === 0) return '-';
  return Math.round((part / total) * 100);
};

const resetIndexes = (): void => {
  currentRowIndex = 4;
  subTotalsIndexes = [];
};

let currentRowIndex = 4;
let subTotalsIndexes = [];
const leftBold: CellStyle = {
  alignment: { horizontal: 'left' },
  font: { bold: true },
};

const left: CellStyle = {
  alignment: { horizontal: 'left' },
};

export const stRow = ['', '', null,
  '', 'Initial investment', '', '', null,
  '', 'Follow-on investment', '', '', null,
  '', 'Total', '', '', null,
  '', ''];


